import { FeatureToggles } from '@paralleldrive/react-feature-toggles';
import { FC } from 'react';
import { useFirestoreConnect } from 'react-redux-firebase';
import { useFeatures } from '../../hooks/queries';

type FeatureControllerProps = {
  children: JSX.Element;
};

export const FeatureController: FC<FeatureControllerProps> = ({
  children,
}: FeatureControllerProps) => {
  useFirestoreConnect(() => [
    {
      collection: 'settings',
      doc: 'features',
      storeAs: 'features',
    },
  ]);

  const features = useFeatures();

  return (
    <FeatureToggles features={features?.available || []}>
      {children}
    </FeatureToggles>
  );
};
